import dataConstants from "../_constants/dataConstants";
import dataService from "../_services/dataService";
import { showToast } from "./appActions";

/* ---------------------------------------------------
    GET MARITAL STATUS
----------------------------------------------------- */
export const getMaritalStatus = payload => dispatch => {
  dataService
    .getMaritalStatus()
    .then(response => {
      dispatch(getMaritalStatusSuccess(response));
    })
    .catch(emptyResponse => {
      dispatch(getMaritalStatusSuccess(emptyResponse));
    });
};

/* ---------------------------------------------------
    GET MARITAL STATUS SUCCESS
----------------------------------------------------- */
const getMaritalStatusSuccess = payload => ({
  type: dataConstants.GET_MARITAL_STATUS,
  payload
});

/* ---------------------------------------------------
    GET MOTHER TONGUE
----------------------------------------------------- */
export const getMotherTongue = payload => dispatch => {
  dataService
    .getMotherTongue()
    .then(response => {
      dispatch(getMotherTongueSuccess(response));
    })
    .catch(emptyResponse => {
      dispatch(getMotherTongueSuccess(emptyResponse));
    });
};

/* ---------------------------------------------------
    GET MOTHER TONGUE SUCCESS
----------------------------------------------------- */
const getMotherTongueSuccess = payload => ({
  type: dataConstants.GET_MOTHER_TONGUE,
  payload
});

/* ---------------------------------------------------
    GET BODY TYPE
----------------------------------------------------- */
export const getBodyType = payload => dispatch => {
  dataService
    .getBodyType()
    .then(response => {
      dispatch(getBodyTypeSuccess(response));
    })
    .catch(emptyResponse => {
      dispatch(getBodyTypeSuccess(emptyResponse));
    });
};
/* ---------------------------------------------------
    GET BODY TYPE SUCCESS
----------------------------------------------------- */
const getBodyTypeSuccess = payload => ({
  type: dataConstants.GET_BODY_TYPE,
  payload
});
/* ---------------------------------------------------
    GET COMPLEXION
----------------------------------------------------- */
export const getComplexion = payload => dispatch => {
  dataService
    .getComplexion()
    .then(response => {
      dispatch(getComplexionSuccess(response));
    })
    .catch(emptyResponse => {
      dispatch(getComplexionSuccess(emptyResponse));
    });
};
/* ---------------------------------------------------
    GET COMPLEXION SUCCESS
----------------------------------------------------- */
const getComplexionSuccess = payload => ({
  type: dataConstants.GET_COMPLEXION,
  payload
});

/* ---------------------------------------------------
    GET DIET
----------------------------------------------------- */
export const getDiet = payload => dispatch => {
  dataService
    .getDiet()
    .then(response => {
      dispatch(getDietSuccess(response));
    })
    .catch(emptyResponse => {
      dispatch(getDietSuccess(emptyResponse));
    });
};

/* ---------------------------------------------------
    GET DIET SUCCESS
----------------------------------------------------- */
const getDietSuccess = payload => ({
  type: dataConstants.GET_DIET,
  payload
});

/* ---------------------------------------------------
    GET HABIT TYPE
----------------------------------------------------- */
export const getHabitType = payload => dispatch => {
  dataService
    .getHabitType()
    .then(response => {
      dispatch(getHabitTypeSuccess(response));
    })
    .catch(emptyResponse => {
      dispatch(getHabitTypeSuccess(emptyResponse));
    });
};

/* ---------------------------------------------------
    GET HABIT TYPE SUCCESS
----------------------------------------------------- */
const getHabitTypeSuccess = payload => ({
  type: dataConstants.GET_HABIT_TYPE,
  payload
});

/* ---------------------------------------------------
    GET JOB TYPE
----------------------------------------------------- */
export const getJobType = payload => dispatch => {
  dataService
    .getJobType()
    .then(response => {
      dispatch(getJobTypeSuccess(response));
    })
    .catch(emptyResponse => {
      dispatch(getJobTypeSuccess(emptyResponse));
    });
};

/* ---------------------------------------------------
    GET JOB TYPE SUCCESS
----------------------------------------------------- */
const getJobTypeSuccess = payload => ({
  type: dataConstants.GET_JOB_TYPE,
  payload
});

/* ---------------------------------------------------
    GET INCOME
----------------------------------------------------- */
export const getIncome = payload => dispatch => {
  dataService
    .getIncome()
    .then(response => {
      dispatch(getIncomeSuccess(response));
    })
    .catch(emptyResponse => {
      dispatch(getIncomeSuccess(emptyResponse));
    });
};

/* ---------------------------------------------------
    GET INCOME SUCCESS
----------------------------------------------------- */
const getIncomeSuccess = payload => ({
  type: dataConstants.GET_INCOME,
  payload
});

/* ---------------------------------------------------
    GET EDUCATION
----------------------------------------------------- */
export const getEducation = payload => dispatch => {
  dataService
    .getEducation()
    .then(response => {
      dispatch(getEducationSuccess(response));
    })
    .catch(emptyResponse => {
      dispatch(getEducationSuccess(emptyResponse));
    });
};

/* ---------------------------------------------------
    GET EDUCATION SUCCESS
----------------------------------------------------- */
const getEducationSuccess = payload => ({
  type: dataConstants.GET_EDUCATION,
  payload
});

/* ---------------------------------------------------
    GET EMPLOYED IN
----------------------------------------------------- */
export const getEmployedIn = payload => dispatch => {
  dataService
    .getEmployedIn()
    .then(response => {
      dispatch(getEmployedInSuccess(response));
    })
    .catch(emptyResponse => {
      dispatch(getEmployedInSuccess(emptyResponse));
    });
};

/* ---------------------------------------------------
    GET EMPLOYED IN SUCCESS
----------------------------------------------------- */
const getEmployedInSuccess = payload => ({
  type: dataConstants.GET_EMPLOYED_IN,
  payload
});

/* ---------------------------------------------------
    GET RELIGION
----------------------------------------------------- */
export const getReligion = payload => dispatch => {
  dataService
    .getReligion()
    .then(response => {
      dispatch(getReligionSuccess(response));
    })
    .catch(emptyResponse => {
      dispatch(getReligionSuccess(emptyResponse));
    });
};

/* ---------------------------------------------------
    GET RELIGION SUCCESS
----------------------------------------------------- */
const getReligionSuccess = payload => ({
  type: dataConstants.GET_RELIGION,
  payload
});
/* ---------------------------------------------------
    GET COMMUNITY BY RELIGION
----------------------------------------------------- */
export const getCommunityByReligion = payload => dispatch => {
  dataService
    .getCommunity(payload)
    .then(response => {
      dispatch(getCommunityByReligionSuccess(response));
    })
    .catch(emptyResponse => {
      dispatch(getCommunityByReligionSuccess(emptyResponse));
    });
};

/* ---------------------------------------------------
    GET COMMUNITY BY RELIGION SUCCESS
----------------------------------------------------- */
const getCommunityByReligionSuccess = payload => ({
  type: dataConstants.GET_COMMUNITY_BY_RELIGION,
  payload
});

/* ---------------------------------------------------
    CREATE COMMUNITY BY RELIGION
----------------------------------------------------- */
export const createCommunityByReligion = payload => dispatch => {
  const { community, religion } = payload;

  dataService
    .createCommunity(religion, community)
    .then(response => {
      dispatch(createCommunityByReligionSuccess(response));
    })
    .catch(emptyResponse => {
      dispatch(createCommunityByReligionSuccess(emptyResponse));
    });
};

/* ---------------------------------------------------
    CREATE COMMUNITY BY RELIGION SUCCESS
----------------------------------------------------- */
const createCommunityByReligionSuccess = payload => ({
  type: dataConstants.CREATE_COMMUNITY_BY_RELIGION,
  payload
});

/* ---------------------------------------------------
    GET CASTE
----------------------------------------------------- */
export const getCaste = () => dispatch => {
  dataService
    .getCaste()
    .then(response => {
      dispatch(getCasteSuccess(response));
    })
    .catch(emptyResponse => {
      dispatch(getCasteSuccess(emptyResponse));
    });
};

/* ---------------------------------------------------
    GET CASTE SUCCESS
----------------------------------------------------- */
const getCasteSuccess = payload => ({
  type: dataConstants.GET_CASTE,
  payload
});

/* ---------------------------------------------------
    GET HEIGHT
----------------------------------------------------- */
export const getHeight = () => dispatch => {
  dataService
    .getHeight()
    .then(response => {
      dispatch(getHeightSuccess(response));
    })
    .catch(emptyResponse => {
      dispatch(getHeightSuccess(emptyResponse));
    });
};

/* ---------------------------------------------------
    GET HEIGHT SUCCESS
----------------------------------------------------- */
const getHeightSuccess = payload => ({
  type: dataConstants.GET_HEIGHT,
  payload
});

/* ---------------------------------------------------
    GET DISABILITY
----------------------------------------------------- */
export const getDisability = () => dispatch => {
  dataService
    .getDisability()
    .then(response => {
      dispatch(getDisabilitySuccess(response));
    })
    .catch(emptyResponse => {
      dispatch(getDisabilitySuccess(emptyResponse));
    });
};

/* ---------------------------------------------------
    GET DISABILITY SUCCESS
----------------------------------------------------- */
const getDisabilitySuccess = payload => ({
  type: dataConstants.GET_DISABILITY,
  payload
});

/* ---------------------------------------------------
    GET FAMILY STATUS
----------------------------------------------------- */
export const getFamilyStatus = () => dispatch => {
  dataService
    .getFamilyStatus()
    .then(response => {
      dispatch(getFamilyStatusSuccess(response));
    })
    .catch(emptyResponse => {
      dispatch(getFamilyStatusSuccess(emptyResponse));
    });
};

/* ---------------------------------------------------
    GET FAMILY STATUS SUCCESS
----------------------------------------------------- */
const getFamilyStatusSuccess = payload => ({
  type: dataConstants.GET_FAMILY_STATUS,
  payload
});

/* ---------------------------------------------------
    GET FAMILY VALUE
----------------------------------------------------- */
export const getFamilyValue = () => dispatch => {
  dataService
    .getFamilyValue()
    .then(response => {
      dispatch(getFamilyValueSuccess(response));
    })
    .catch(emptyResponse => {
      dispatch(getFamilyValueSuccess(emptyResponse));
    });
};

/* ---------------------------------------------------
    GET FAMILY VALUE SUCCESS
----------------------------------------------------- */
const getFamilyValueSuccess = payload => ({
  type: dataConstants.GET_FAMILY_VALUE,
  payload
});

/* ---------------------------------------------------
    GET FAMILY TYPE
----------------------------------------------------- */
export const getFamilyType = () => dispatch => {
  dataService
    .getFamilyType()
    .then(response => {
      dispatch(getFamilyTypeSuccess(response));
    })
    .catch(emptyResponse => {
      dispatch(getFamilyTypeSuccess(emptyResponse));
    });
};

/* ---------------------------------------------------
    GET FAMILY TYPE SUCCESS
----------------------------------------------------- */
const getFamilyTypeSuccess = payload => ({
  type: dataConstants.GET_FAMILY_TYPE,
  payload
});

/* ---------------------------------------------------
    GET HOUSE TYPE
----------------------------------------------------- */
export const getHouseType = () => dispatch => {
  dataService
    .getHouseType()
    .then(response => {
      dispatch(getHouseTypeSuccess(response));
    })
    .catch(emptyResponse => {
      dispatch(getHouseTypeSuccess(emptyResponse));
    });
};

/* ---------------------------------------------------
    GET HOUSE TYPE SUCCESS
----------------------------------------------------- */
const getHouseTypeSuccess = payload => ({
  type: dataConstants.GET_HOUSE_TYPE,
  payload
});

/* ---------------------------------------------------
    GET MOON SIGN
----------------------------------------------------- */
export const getMoonSign = () => dispatch => {
  dataService
    .getMoonSign()
    .then(response => {
      dispatch(getMoonSignSuccess(response));
    })
    .catch(emptyResponse => {
      dispatch(getMoonSignSuccess(emptyResponse));
    });
};

/* ---------------------------------------------------
    GET MOON SIGN SUCCESS
----------------------------------------------------- */
const getMoonSignSuccess = payload => ({
  type: dataConstants.GET_MOON_SIGN,
  payload
});

/* ---------------------------------------------------
    GET CREATED BY
----------------------------------------------------- */
export const getCreatedBy = () => dispatch => {
  dataService
    .getCreatedBy()
    .then(response => {
      dispatch(getCreatedBySuccess(response));
    })
    .catch(emptyResponse => {
      dispatch(getCreatedBySuccess(emptyResponse));
    });
};

/* ---------------------------------------------------
    GET CREATED BY SUCCESS
----------------------------------------------------- */
const getCreatedBySuccess = payload => ({
  type: dataConstants.GET_CREATED_BY,
  payload
});

/* ---------------------------------------------------
    GET COUNTRY
----------------------------------------------------- */
export const getCountry = payload => dispatch => {
  dataService
    .getCountry()
    .then(response => {
      dispatch(getCountrySuccess(response));
    })
    .catch(emptyResponse => {
      dispatch(getCountrySuccess(emptyResponse));
    });
};

/* ---------------------------------------------------
    GET COUNTRY SUCCESS
----------------------------------------------------- */
const getCountrySuccess = payload => ({
  type: dataConstants.GET_COUNTRY,
  payload
});
/* ---------------------------------------------------
    GET STATE BY COUNTRY
----------------------------------------------------- */
export const getStateByCountry = payload => dispatch => {
  dataService
    .getState(payload)
    .then(response => {
      dispatch(getStateByCountrySuccess(response));
    })
    .catch(emptyResponse => {
      dispatch(getStateByCountrySuccess(emptyResponse));
    });
};

/* ---------------------------------------------------
    GET STATE BY COUNTRY SUCCESS
----------------------------------------------------- */
const getStateByCountrySuccess = payload => ({
  type: dataConstants.GET_STATE_BY_COUNTRY,
  payload
});



// WEBPACK FOOTER //
// ./src/_actions/dataActions.js